import React, { useEffect, useState } from "react";
import VesselTable from "../../components/Admin/Vessels/VesselTable";
import AddEditVesselModal from "../../components/Admin/Vessels/AddEditVesselModal";
import {
  getAllVessels,
  deleteVessel
} from "../../services/vesselService";
import { toast } from "react-hot-toast";

const VesselManagement = () => {
  const [vessels, setVessels] = useState([]);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editVessel, setEditVessel] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchVessels = async () => {
    const res = await getAllVessels();
    if (res.status === "success") {
      setVessels(res.data);
    } else {
      console.error("Failed to fetch vessels");
    }
  };

  useEffect(() => {
    fetchVessels();
  }, []);

  const handleAddVessel = () => setIsAddOpen(true);

  const handleModalSubmit = () => {
    toast.success("Vessel added successfully!");
    fetchVessels(); // ✅ Refresh the list
    setIsAddOpen(false); // ✅ Close modal
  };

  const handleEdit = (vessel) => {
    setEditVessel(vessel);
    setIsAddOpen(true);
  };

  const handleDelete = async (vesselId) => {
    const res = await deleteVessel(vesselId);
    if (res.status === "success") {
      toast.success("Vessel deleted");
      fetchVessels();
    } else {
      toast.error("Failed to delete vessel.");
    }
  };

  return (
    <div className="">
      <VesselTable
        vessels={vessels}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onVesselAdded={fetchVessels}
      />

      <AddEditVesselModal
        open={isAddOpen}
        onClose={() => {
          setIsAddOpen(false);
          setEditVessel(null);
        }}
        onSubmit={() => {
          fetchVessels();
          setIsAddOpen(false);
          setEditVessel(null);
        }}
        mode={editVessel ? "edit" : "add"}
        vessel={editVessel}
      />
    </div>
  );
};

export default VesselManagement;
